import './style.scss'

import download from '../common/js/download.js'

const run = x => x()

const ready = () =>
  [
    // components
    download
  ].map(run)

export function initialize() {
  ready()
}
